import { Injectable, signal } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MpsLoaderService {
  private _apiCount = 0;
  private _isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this._isLoadingSubject.asObservable();
  private _displayLoader = signal<boolean>(true);
  private _calls: number[] = [];

  isLoading(): boolean {
    return this._isLoadingSubject.value;
  }

  showLoader(id: number) {
    if (this._displayLoader()) {
      if (this._apiCount === 0) {
        this._isLoadingSubject.next(true);
      }
      this._apiCount++;
      this._calls.push(id);
    }
  }

  hideLoader(id: number) {
    if (this._displayLoader() || this._calls.includes(id)) {
      this._apiCount--;
      if (this._apiCount === 0) {
        this._isLoadingSubject.next(false);
      }
      this._calls = this._calls.filter((callId) => callId !== id);
    }
  }

  // Be careful when using this method and ensure to call enableAutoLoader after the response
  // is received, otherwise you could end up with an invalid value for _apiCount
  disableAutoLoader() {
    this._displayLoader.set(false);
  }

  enableAutoLoader() {
    this._displayLoader.set(true);
  }

  generateRandomId(): number {
    let id = Math.random() * 1000000000;
    while (this._calls.includes(id)) {
      id = Math.random() * 1000000000;
    }

    return id;
  }
}
